import { QuickStatsMessage } from '../../../../types/QuickStatsMessage';
import { formatNumber } from '../../../common/helpers/formatNumber.helper';
import { translate } from '../../../common/helpers/translate.helper';

import { StatsItem } from './StatsItem';

interface VolumeStatsItemProps {
    stats: QuickStatsMessage;
}

export const VolumeStatsItem = ({ stats }: VolumeStatsItemProps) => {
    return (
        <StatsItem
            item={`${formatNumber({ number: stats.volume })} L`}
            description={translate('dashboard.quickstats.volume')}
        />
    );
};
